module.exports = __webpack_public_path__ + "static/media/senddesk.64a9e33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/senddesk.png
// module id = 19
// module chunks = 0